export const MONTH_NAMES = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
] as const;

export function monthName(month: number): string {
  return MONTH_NAMES[month - 1] ?? String(month);
}

export function periodLabel(p: { year: number; month: number }): string {
  return `${monthName(p.month)} ${p.year}`;
}

const numberFormats = new Map<number, Intl.NumberFormat>();
export function formatNumber(value: number | null | undefined, decimals = 0): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  let fmt = numberFormats.get(decimals);
  if (!fmt) {
    fmt = new Intl.NumberFormat('es-ES', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
      useGrouping: 'always',
    });
    numberFormats.set(decimals, fmt);
  }
  return fmt.format(value);
}

export function formatEuros(value: number | null | undefined): string {
  return value === null || value === undefined ? '—' : `${formatNumber(value)} €`;
}

export function formatPercent(value: number | null | undefined, decimals = 1): string {
  return value === null || value === undefined ? '—' : `${formatNumber(value * 100, decimals)}%`;
}

export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString('es-ES', { dateStyle: 'short', timeStyle: 'short' });
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024 * 1024) return `${formatNumber(bytes / 1024, 0)} KB`;
  return `${formatNumber(bytes / (1024 * 1024), 1)} MB`;
}
